export enum ProvidersAvailableNotificationsTypesNames {
  MonitoringScheduledConversion = 'monitoring_scheduled_conversion',
  ScheduledRejectReasonNotification = 'scheduled_reject_reason_notification',
}

export const PROVIDERS_AVAILABLE_NOTIFICATIONS_TYPES = [
  ProvidersAvailableNotificationsTypesNames.MonitoringScheduledConversion,
  ProvidersAvailableNotificationsTypesNames.ScheduledRejectReasonNotification,
];
